import React, { useState, useEffect } from "react";

import { AdContainer } from "../../ads";
import useAdType from "../../helper/useAdType";
import LatestNews from "../story-elements/latest-news";

import "./story-sidebar.m.css";

const StorySideBar = ({ story, id = "story" }) => {
  const [isMobile, setMobile] = useState(true);

  const adType = useAdType();
  const tempHideAd =
    (story && story["story-template"] === "brandspot-with-no-ad") ||
    story?.slug?.includes("dhbrandspot-pr/best-crypto-casinos-2025-my-go-to-sites-for-bitcoin-gambling-3470705");

  useEffect(() => {
    if (window && window.innerWidth > 767) {
      setMobile(false);
    } else {
      setMobile(true);
    }
  }, []);
  return !isMobile ? (
    <div styleName="wrapper" className="hide-mobile">
      {!tempHideAd ? (
        <div styleName="ad">
          <div className="hide-mobile">
            <AdContainer
              AdClassName="standard-300x250"
              id={adType === "izooto" ? "div-gpt-ad-1711971483406-0" : `div-gpt-ad-1689838093828-0-${id}`}
              desktop={adType === "izooto" ? "DH_Desktop_AT_RT_ym" : "DH_Desktop_AT_RT"}
              isExternalAdPath={adType === "izooto" ? true : false}
            />
          </div>
        </div>
      ) : null}
      <div styleName="latest-news">
        <LatestNews story={story} />
      </div>
      {!tempHideAd ? (
        <div styleName="ad sticky-ad">
          <div className="hide-mobile" styleName="extra-space">
            <AdContainer
              AdClassName="standard-300x600"
              id={adType === "izooto" ? "div-gpt-ad-1711971737656-0" : `div-gpt-ad-1689838240664-0-${id}`}
              desktop={adType === "izooto" ? "DH_Desktop_AT_RM_ym" : "DH_Desktop_AT_RM"}
              isExternalAdPath={adType === "izooto" ? true : false}
            />
          </div>
        </div>
      ) : null}
    </div>
  ) : null;
};

export default StorySideBar;
